import { useCookies} from "@vueuse/integrations/useCookies";
import { ref } from "vue";


const useBookingSession = () => {
  const cookies = useCookies(['booking']);

  const bookingUuid = ref(null);

  cookies.addChangeListener(({ name, value }) => {
    if (name === 'booking') {
      bookingUuid.value = value;
    }
  })

  const getBooking = () => {
    return cookies.get('booking', {
      path: window.Laravel.cookiePath,
    }) || null;
  }

  const setBooking = (booking: any) => {
    cookies.set('booking', booking.uuid, {
      path: window.Laravel.cookiePath,
      expires: new Date(booking.expire_at)
    });
  }

  const removeBooking = () => {
    cookies.remove('booking', {
      path: window.Laravel.cookiePath,
    });
  }

  bookingUuid.value = getBooking();

  return {
    bookingUuid,
    getBooking,
    setBooking,
    removeBooking
  }
}

export default useBookingSession;